import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll position to the top whenever the route changes (e.g. clicking a sidebar
// link while scrolled far down a long page). Without this, React Router preserves the
// browser's scroll position across navigations, so a newly-loaded page can render entirely
// below the fold and look blank/unchanged.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
